import { Link } from "react-router-dom";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-update">Last updated: Thursday, 17 April 2025</p>

        <div className="privacy-content">
          <h2 className="privacy-subtitle">WHO WE ARE</h2>
          <p>
            Our website URL is{" "}
            <a href="https://healthwiibes.com/" className="privacy-link">
              https://healthwiibes.com/
            </a>
            . We are your trusted source for everything related to health and fitness, and we want to help people with our tool "Ideal weight calculator". Our goal is to provide you with accurate, current information, expert insights, and tips for ideal weight to help you live a healthier and happier life. Although we do not guarantee that our tool will always display correct data.
          </p>

          <h2 className="privacy-subtitle">COMMENTS</h2>
          <p>
            When visitors leave comments on the site, we collect the information entered in the comments form, along with the visitor's IP address and browser user agent string to identify and prevent spam. Once your comment is approved, your profile picture becomes visible to the public in connection with your comment.
          </p>

          <h2 className="privacy-subtitle">MEDIA</h2>
          <p>
            As an author, if you upload images to the website, please avoid including location data (EXIF GPS) in them. Visitors can download and extract location data from images on the website.
          </p>

          <h2 className="privacy-subtitle">COOKIES</h2>
          <p>
            If you leave a comment on our site, you may choose to save your name, email address, and website in cookies for convenience. This way, you won't need to fill in your details again when leaving another comment. These cookies will last for one year. Additionally, when you edit or publish an article, an additional cookie is saved in your browser, indicating the post ID of the edited article. This cookie contains no personal data and expires after one day.
          </p>

          <h2 className="privacy-subtitle">EMBEDDED CONTENT FROM OTHER WEBSITES</h2>
          <p>
            Articles on this site may contain embedded content (e.g., videos, images, articles) from other websites. This embedded content behaves the same way as if you visited the other website, and these websites may collect data, use cookies, and track your interaction with the embedded content.
          </p>

          <h2 className="privacy-subtitle">HOW LONG WE RETAIN YOUR DATA</h2>
          <p>
            Comments and their metadata, including your profile picture, are retained indefinitely. This is done to automatically recognize and approve follow-up comments, avoiding the need for manual moderation.
          </p>

          <h2 className="privacy-subtitle">YOUR DATA RIGHTS</h2>
          <p>
            If you have an author account or have left comments, you can request an exported file of your personal data held by us. You can also ask us to erase any personal data we have about you, except for data required for administrative, legal, or security purposes.
          </p>

          <h2 className="privacy-subtitle">WHERE YOUR DATA IS SENT</h2>
          <p>
            Visitor comments may undergo automated spam detection before being approved to appear on the website.
          </p>

          <h2 className="privacy-subtitle">CONTACT US</h2>
          <p>
            You can reach us via email or by sending a direct query through the contact form on our website. Email us at:{" "}
            <a href="mailto:healthwiibes@gmail.com" className="privacy-link">
              healthwiibes@gmail.com
            </a>
          </p>
        </div>

        <div className="privacy-footer">
          <Link to="/" className="privacy-home-link">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;